import React, { useState } from "react";
import {
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  DataTableSkeleton,
  Button,
} from "@carbon/react";
import { UserFollow } from "@carbon/icons-react";
import "./coworkersDataTable.scss";
import AddItemModal from "../addItemModal/AddItemModal";
import { useTranslation } from "react-i18next";

export default function CoworkersDataTable({ data, pending, guid, isMobile }) {
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();

  function mapToTableData(data) {
    const headers = [
      {
        header: "main.chat.coworkersTable.name",
        key: "name",
      },
    ];

    const rows = Array.isArray(data)
      ? data.map((item) => ({
          name: String(item.nick),
          id: String(item.id),
        }))
      : [];

    return { headers, rows };
  }

  const { headers, rows } = mapToTableData(data?.coworkers);

  const nicknames = data?.coworkers?.map((c) => c.nick);

  const isDisabled =
    !Array.isArray(data?.coworkers) ||
    data.coworkers.length === 0 ||
    rows.length >= 1;

  return (
    <div className="main_chat_coworkers">
      {pending ? (
        <DataTableSkeleton
          aria-label="sample table"
          headers={[
            {
              header: t("main.chat.coworkersTable.name"),
              key: "name",
            },
          ]}
          showHeader
          showToolbar
        />
      ) : (
        <DataTable
          size="lg"
          headers={headers}
          rows={rows}
          isSortable
          render={({ rows, headers, onInputChange }) => (
            <TableContainer
              title={
                <div className="main_chat_info_title">
                  <span>{`${t("main.chat.coworkersTable.title", {
                    context: data?.kind,
                  })}`}</span>
                  <div className="main_relations_button_set">
                    <Button
                      kind="primary"
                      hasIconOnly={isMobile}
                      iconDescription={t(
                        "main.chat.coworkersTable.addCoworkerButton",
                      )}
                      renderIcon={UserFollow}
                      onClick={() => setOpenModal(true)}
                      disabled={isDisabled}
                    >
                      {t("main.chat.coworkersTable.addCoworkerButton")}
                    </Button>
                  </div>
                </div>
              }
              description={`${t("main.chat.coworkersTable.description")}`}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    {headers.map((header) => {
                      return (
                        <TableHeader key={header.key}>
                          {t(header.header)}
                        </TableHeader>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.id}>
                      {row.cells.map((cell) => (
                        <TableCell key={cell.id}>{cell.value}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        />
      )}

      {openModal && (
        <AddItemModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          data={nicknames}
          table={"coworkers"}
          guid={guid}
        />
      )}
    </div>
  );
}
